import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { SedsCheckFormTypeService } from '../../shared/services/seds-check-form-type/seds-check-form-type.service';
import { SedsTooltipComponent } from './seds-tooltip.component';
import { SedsTooltipDirective } from './directives/seds-tooltip.directive';

@NgModule({
  declarations: [SedsTooltipComponent, SedsTooltipDirective],
  imports: [CommonModule, FormsModule, MatCheckboxModule, ReactiveFormsModule],
  exports: [SedsTooltipDirective],

  providers: [FormGroupDirective, SedsCheckFormTypeService],
})
export class SedsTooltipModule {}
